module.exports = __webpack_public_path__ + "static/media/elements.9ac36b0d.png";